import React from "react";
import "../css/privacy.scss";
import PolicyPage from "./PolicyPage";

function CookiePolicy() {
  return (
    <PolicyPage title="Cookie Policy">
      <p><em>Last updated: October 9, 2026</em></p>
      <p>Cookies are small data files stored by your browser. This page explains the categories that may be used when you visit the danecay store.</p>
      <h2>Essential Cookies</h2>
      <p>These support core features such as page navigation, cart contents, checkout continuity, security and fraud prevention. The store may not function correctly without them.</p>
      <h2>Preference Cookies</h2>
      <p>These remember choices such as region or interface settings so you do not need to select them repeatedly.</p>
      <h2>Analytics Cookies</h2>
      <p>If enabled, these help us understand aggregated page use, errors and performance. We use this information to improve the store rather than to sell individual browsing profiles.</p>
      <h2>Payment and Service Cookies</h2>
      <p>The payment provider and other required service partners may set their own cookies when their features are used. Their privacy and cookie notices govern those files.</p>
      <h2>Managing Cookies</h2>
      <p>You can block or remove cookies in your browser settings. Blocking essential cookies may prevent the cart or checkout from working. Questions can be sent to <a href="mailto:core@danecay.shop">core@danecay.shop</a>.</p>
    </PolicyPage>
  );
}

export default CookiePolicy;
